import { render, staticRenderFns } from "./OperaArticleLabelsWindow.vue?vue&type=template&id=67ad9220&scoped=true&"
import script from "./OperaArticleLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaArticleLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaArticleLabelsWindow.vue?vue&type=style&index=0&id=67ad9220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad9220",
  null
  
)

export default component.exports